import { GOAL_STEPS } from '../../../types/enum';

const workoutHours = [
  { key: '0 mins', value: 0 },
  { key: '10 mins', value: 10 },
  { key: '15 mins', value: 15 },
  { key: '20 mins', value: 20 },
  { key: '30 mins', value: 30 },
  { key: '45 mins', value: 45 },
  { key: '1 hour', value: 60 },
  { key: '1 and half an hour', value: 90 },
  { key: '2 hours', value: 120 },
  { key: 'More than 2 hours', value: 180 },
];

const workoutDays = [
  { key: '0 day', value: 0 },
  { key: '1 day', value: 1 },
  { key: '2 days', value: 2 },
  { key: '3 days', value: 3 },
  { key: '4 days', value: 4 },
  { key: '5 days', value: 5 },
  { key: '6 days', value: 6 },
  { key: 'every day', value: 7 },
];

const DailyWorkout = ({ goals, setGoals, setCurrentStep }) => {
  const handleInput = (key) => (e) => {
    const value = e.target.value;
    if (key === 'hours') {
      setGoals((prev) => ({ ...prev, workoutHours: value }));
    }
    if (key === 'days') {
      setGoals((prev) => ({ ...prev, workoutDays: value }));
    }
  };

  const handleNext = () => {
    try {
      setCurrentStep(GOAL_STEPS.DAILY_CALORIE);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 className='font-bold mb-3 text-white text-2xl'>
        How much time do(will) you spend working out each week?
      </h1>
      <div className='leading-10 mb-5'>
        <div>
          <span className='text-white text-sm font-bold'>I (will) spend </span>
          <select
            onChange={handleInput('hours')}
            value={goals.workoutHours}
            className='rounded-full px-2 py-1 bg-white '
          >
            <option
              key='select'
              disabled
            >
              select hours
            </option>
            {workoutHours.map((hours) => (
              <option
                key={hours.key}
                value={hours.value}
              >
                {hours.key}
              </option>
            ))}
          </select>
        </div>
        <div>
          <span className='text-white text-sm font-bold'> working out </span>
          <select
            onChange={handleInput('days')}
            value={goals.workoutDays}
            className='rounded-full px-2 py-1 bg-white '
          >
            <option
              key='select'
              disabled
            >
              select days
            </option>
            {workoutDays.map((days) => (
              <option
                key={days.key}
                value={days.value}
              >
                {days.key}
              </option>
            ))}
          </select>
          <span className='text-white text-sm font-bold'> of the week.</span>
        </div>
      </div>
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 ${
          !goals.workoutHours || !goals.workoutDays
            ? 'opacity-40'
            : 'hover:bg-yellow-600 transition-colors duration-200'
        }`}
        onClick={handleNext}
        disabled={!goals.workoutHours || !goals.workoutDays}
      >
        Next
      </button>
    </div>
  );
};

export default DailyWorkout;
